"use strict";
exports.__esModule = true;
exports.PopupBase = void 0;
var helper_1 = require("./helper");
var PopupBase = /** @class */ (function () {
    function PopupBase(element) {
        var _this = this;
        this.popup_container_element = helper_1.get_element_by_id_or_fail('yd-ph-popups-container', HTMLDivElement);
        this.base_element = element;
        this.base_element.addEventListener('click', function (event) { return _this.click(event); });
        this.content_layer_element = helper_1.get_first_element_by_class_or_fail(this.base_element, 'yd-ph-popup__content-layer', HTMLDivElement);
        this.attach_api_to_element();
    }
    PopupBase.prototype.open = function () {
        if (PopupBase.open_popups === 0)
            this.popup_container_element.classList.add('js-show');
        PopupBase.open_popups++;
        this.base_element.classList.add('js-show');
    };
    PopupBase.prototype.close = function () {
        this.base_element.classList.remove('js-show');
        PopupBase.open_popups--;
        if (PopupBase.open_popups === 0)
            this.popup_container_element.classList.remove('js-show');
    };
    PopupBase.prototype.is_open = function () {
        return this.base_element.classList.contains('js-show');
    };
    PopupBase.prototype.toggle = function () {
        if (this.is_open()) {
            this.close();
        }
        else {
            this.open();
        }
    };
    PopupBase.prototype.get_name = function () {
        return this.base_element.getAttribute('data-name');
    };
    PopupBase.prototype.is_named = function () {
        return this.get_name() !== null;
    };
    PopupBase.prototype.trigger_action = function (action_name, target) {
        switch (action_name) {
            case 'close':
                this.close();
                break;
            default:
                {
                    if (action_name in this) {
                        var callback_function = this[action_name].bind(this);
                        if (typeof callback_function === "function") {
                            callback_function(target);
                        }
                    }
                }
                break;
        }
    };
    PopupBase.prototype.click = function (event) {
        var target = event.target;
        while (target && target !== this.base_element) {
            if (target instanceof HTMLElement) {
                var action_name = target.getAttribute('data-action');
                if (action_name) {
                    this.trigger_action(action_name, target);
                }
                // only one action
                return;
            }
        }
    };
    PopupBase.prototype.attach_api_to_element = function () {
        var element = this.base_element;
        if (!("data" in element))
            element.data = {};
        element.data.popup_api = this;
    };
    PopupBase.open_popups = 0;
    return PopupBase;
}());
exports.PopupBase = PopupBase;
